import { BaseIRemoteApi } from './api.base';
import { apiNet } from '@cems-eco/core/src/services/api';

export class CloudIRemoteApi extends BaseIRemoteApi {

    async all(): Promise<any> {
        return await apiNet.get<any>(this.BASE_URL);
    }

    iremoteUrl(): string {
        return apiNet.getUrl(this.BASE_URL)
    }
}